import { FC } from 'react'

import { TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Flex } from 'components/uiKit'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { URLS } from 'shared/constants/urls'
import { AdriverEventType, EventType } from 'types/types'

import Arrow from 'assets/img/shared/arrow.svg?react'
import DownloadArrow from 'assets/img/shared/downloadArrow.svg?react'
import s from './PromoLink.module.scss'

interface AuctionItem {
  title: string
  description: string
  linkText: string
  linkHref: string
  eventSection?: string
}

interface AuctionProps {
  data: AuctionItem[]
  isDownloadLink: boolean
}

export const PromoLink: FC<AuctionProps> = ({ data, isDownloadLink }) => {
  const { isTablet, isSTablet } = useResize()

  const handleClickLink = (link: string, section?: string) => {
    if (isDownloadLink) sendEvent(EventType.BrandbookDnl, { type: 'Simplified' })
    if (section) sendEvent(EventType.MainCartPUPT, { section })
    if (link === URLS.auction) {
      sendAdriverEvent(AdriverEventType.showVariants)
    } else return
  }

  return (
    <div className={s.PromoLink}>
      {data.map((item, index) => (
        <Flex className={s.promoLinkWrapper} vertical={isSTablet} key={index}>
          <Flex vertical gap={isTablet ? 6 : 4}>
            <TextPromo size={isTablet ? 's20' : 's32'} weight="w700">
              {item.title}
            </TextPromo>
            <TextPromo size={isTablet ? 's16' : 's24'} fontFamily="ASLHaussVF" color="gray">
              {item.description}
            </TextPromo>
          </Flex>
          <Href
            href={item.linkHref}
            target="_blank"
            linkType="search"
            className={s.link}
            onClick={() => handleClickLink(item.linkHref, item.eventSection)}
          >
            <TextPromo size={isTablet ? 's16' : 's24'} fontFamily="ASLHaussVF" className={s.text}>
              {item.linkText}
            </TextPromo>
            <div className={s.arrowWrapper}>
              {isDownloadLink ? <DownloadArrow style={{ rotate: '0deg', width: '44px', height: '44px' }} /> : <Arrow />}
            </div>
          </Href>
        </Flex>
      ))}
    </div>
  )
}
